import { jsxs as p, jsx as l } from "react/jsx-runtime";
import { useState as _, useMemo as v, useRef as x } from "react";
import { buildClassNames as e } from "../../style/build-class-names.mjs";
import { FlagEmoji as h } from "../flag-emoji/flag-emoji.mjs";
import { CountrySelectorDropdown as D } from "./country-selector-dropdown.mjs";
import { DEFAULT_COUNTRY as S } from "../../constants/default-country.mjs";
import { defaultCountries as g } from "../../constants/default-countries.mjs";
import { getCountry as j } from "../../utils/country-utils/get-country.mjs";
const T = ({
  selectedCountry: r,
  onSelect: i,
  disabled: a,
  hideDropdown: u,
  defaultCountry: f = S,
  countries: c = g,
  renderButtonWrapper: w,
  ...o
}) => {
  const [n, s] = _(!1), m = v(() => {
    if (r)
      return j({
        value: r,
        field: "iso2",
        countries: c,
        defaultCountry: f
      });
  }, [c, f, r]), N = x(null), y = (t) => {
    t.key && ["ArrowUp", "ArrowDown"].includes(t.key) && (t.preventDefault(), s(!0));
  }, C = () => {
    const t = {
      title: m == null ? void 0 : m.name,
      onClick: () => s((d) => !d),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (d) => d.preventDefault(),
      onKeyDown: y,
      disabled: u || a,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": n
    }, b = /* @__PURE__ */ p(
      "div",
      {
        className: e({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [o.buttonContentWrapperClassName]
        }),
        style: o.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ l(
            h,
            {
              iso2: r,
              className: e({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  a && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [o.flagClassName]
              }),
              style: {
                visibility: r ? "visible" : "hidden",
                ...o.flagStyle
              }
            }
          ),
          !u && /* @__PURE__ */ l(
            "div",
            {
              className: e({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  a && "country-selector-button__dropdown-arrow--disabled",
                  n && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [o.dropdownArrowClassName]
              }),
              style: o.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return w ? w({
      children: b,
      rootProps: t
    }) : /* @__PURE__ */ l(
      "button",
      {
        ...t,
        type: "button",
        className: e({
          addPrefix: [
            "country-selector-button",
            n && "country-selector-button--active",
            a && "country-selector-button--disabled",
            u && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [o.buttonClassName]
        }),
        "data-country": r,
        style: o.buttonStyle,
        children: b
      }
    );
  };
  return /* @__PURE__ */ p(
    "div",
    {
      className: e({
        addPrefix: ["country-selector"],
        rawClassNames: [o.className]
      }),
      style: o.style,
      ref: N,
      children: [
        C(),
        /* @__PURE__ */ l(
          D,
          {
            show: n,
            countries: c,
            onSelect: (t) => {
              s(!1), i == null || i(t);
            },
            selectedCountry: r,
            onClose: () => {
              s(!1);
            },
            ...o.dropdownStyleProps
          }
        )
      ]
    }
  );
};
export {
  T as CountrySelector
};
